import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/user_group_table'
import UserGroupService from '../../network/services/user_group'
import { serialize } from '../../network/request'
import UserGroupTable from './UserGroupTable'

const UserGroupPage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create User Group
    </Button>
  )

  return (
    <PageHeader title="All User Groups" extra={[primaryAction]}>
      <Card>
        <UserGroupTableWrapper />
      </Card>
    </PageHeader>
  )
}

const UserGroupTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(UserGroupService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = UserGroupService.toPaginate(response)

  return (
    <>
      <UserGroupTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <UserGroupTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default UserGroupPage
